//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { QueryRenderer, ReadyState } from "react-relay";
// team health dashboard imports
import { IRendererProps, IRendererContainer } from "./AutopilotList.d";
import { AutopilotList } from "./AutopilotList";
import { query } from "./AutopilotList.gql";
import { styles } from "./AutopilotList.styles";
// other internals
import { CalloutBox } from "@components/callout-box";
import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";
// state
import { IReduxState } from "@reducers/root.reducer";
// util
import { getRenderTimeZone } from "@util/time-zone.util";
import { handleReadyStateError } from "@util/relay.util";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
export class AutopilotListRendererCmpt extends React.Component<IRendererProps> {
  private renderLoader() {
    return (
      <div className={this.props.classes.content}>
        <div className={this.props.classes.background}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  public render() {
    const {
      calendarId,
      environment,
      onClick,
      onLoad,
      orgId,
      selectedExternalEventId,
      type,
      showHistory,
    } = this.props;

    return (
      <QueryRenderer
        environment={environment}
        query={query}
        variables={{
          calendarId,
          userCalendarIds: [calendarId],
          orgRelayId: orgId,
          timeZone: getRenderTimeZone(),
          calendarIds: [],
          externalEventIds: [],
        }}
        cacheConfig={{ force: true }}
        render={(readyState: ReadyState) => {
          const org = readyState.props && readyState.props.org;

          // check for error or show a loader for first load
          if (readyState.error) {
            handleReadyStateError(readyState.error, "AutopilotListRenderer");

            return (
              <CalloutBox warning style={{ marginTop: 20 }}>
                Sorry, loading your Autopilot meetings failed. Please return home using the back
                arrow above and try again.
              </CalloutBox>
            );
          }

          if (org) {
            return (
              <AutopilotList
                selectedExternalEventId={selectedExternalEventId}
                mode={type}
                showHistory={showHistory}
                onClick={onClick}
                onLoad={onLoad}
                org={org}
                orgRefetch={org}
                calendarId={calendarId}
              />
            );
          }

          return this.renderLoader();
        }}
      />
    );
  }
}

//////////////////
// STYLES
//////////////////
const AutopilotListRendererStyled = withStyles(styles)(AutopilotListRendererCmpt);

//////////////////
// REDUX
//////////////////
export const AutopilotListRenderer = connect(
  (_state: IReduxState, _ownProps: IRendererContainer) => ({}),
  {},
)(AutopilotListRendererStyled);
